// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  companyName: 'SureSystems',
  companyWWWURL: 'https://www.suresystems.co.za/',
  appVersion: '26.11.001',
  appAPIVersion: '1.001',

  useServicepointAccess: true,

  logo: '/assets/img/SureDebit200.png',
  fullLogo: '/assets/img/SureDebit200.png',

  logoLink: 'https://setup-uat.suredebit.co.za/dashboard',
  logoTitle: '',
  logoStyle: '',
  logoPadding: '45px 0',
  defaultSidebarColor: 'black',
  loginBackground: './assets/img/ssbackground.jpg',

  currencyCode: 'ZAR',
  currency: 'R',

  REST_SERVER_HOST: 'https://setup-uat.suredebit.co.za',
  REST_SERVER_url: [
    {
      api: 'PADM', url: '/api/portaladmin'
    },
    {
      api: 'SDSETUP', url: '/api/suredebitsetup'
    },
    {
      api: 'EDOSETUP', url: '/api/edossetup'
    },
    {
      api: 'MBE', url: '/api/mbengine_ens'
    },
  ],
  debug: false,

  appconsumer: "jk8mfSwbTmzBfiDMK0rqLH7NwW4Yr2x3e",

  auth: {
    clientID: 'ybbvv84pTKPs94Si1pF1ApTGwN3DoZgz',
    domain: 'surecollect-dev.auth0.com', // e.g., you.auth0.com
    responseType: 'token id_token',
    audience: 'https://portaladminapi.suredebit.co.za', // e.g., http://localhost:3001
    redirect: 'https://setup-uat.suredebit.co.za/callback',
    scope: 'openid profile email'  //  openid profile email groups permissions roles
  },
  logoutURL: 'https://setup-uat.suredebit.co.za/',
  MINUTES_UNITL_AUTO_LOGOUT: 15, // in Minutes
  CHECK_INTERVALL: 1000 // in ms
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
